var map = {
	"./account": [
		"90ee",
		"chunk-2d0e4aed"
	],
	"./account/": [
		"90ee",
		"chunk-2d0e4aed"
	],
	"./account/Account": [
		"3d18"
	],
	"./account/Account.vue": [
		"3d18"
	],
	"./account/index": [
		"90ee",
		"chunk-2d0e4aed"
	],
	"./account/index.js": [
		"90ee",
		"chunk-2d0e4aed"
	],
	"./admin": [
		"f4b8",
		"chunk-2d22ce1a"
	],
	"./admin/": [
		"f4b8",
		"chunk-2d22ce1a"
	],
	"./admin/Admin": [
		"546f"
	],
	"./admin/Admin.vue": [
		"546f"
	],
	"./admin/index": [
		"f4b8",
		"chunk-2d22ce1a"
	],
	"./admin/index.js": [
		"f4b8",
		"chunk-2d22ce1a"
	],
	"./dataprivacy": [
		"fc07",
		"chunk-2d23787a"
	],
	"./dataprivacy/": [
		"fc07",
		"chunk-2d23787a"
	],
	"./dataprivacy/Dataprivacy": [
		"c6e6"
	],
	"./dataprivacy/Dataprivacy.vue": [
		"c6e6"
	],
	"./dataprivacy/index": [
		"fc07",
		"chunk-2d23787a"
	],
	"./dataprivacy/index.js": [
		"fc07",
		"chunk-2d23787a"
	],
	"./error": [
		"58f0",
		"chunk-2d0c9763"
	],
	"./error/": [
		"58f0",
		"chunk-2d0c9763"
	],
	"./error/Error": [
		"e839"
	],
	"./error/Error.vue": [
		"e839"
	],
	"./error/index": [
		"58f0",
		"chunk-2d0c9763"
	],
	"./error/index.js": [
		"58f0",
		"chunk-2d0c9763"
	],
	"./home": [
		"e04b",
		"chunk-2d22454f"
	],
	"./home/": [
		"e04b",
		"chunk-2d22454f"
	],
	"./home/Home": [
		"5c28"
	],
	"./home/Home.vue": [
		"5c28"
	],
	"./home/index": [
		"e04b",
		"chunk-2d22454f"
	],
	"./home/index.js": [
		"e04b",
		"chunk-2d22454f"
	],
	"./imprint": [
		"6c57",
		"chunk-2d0da745"
	],
	"./imprint/": [
		"6c57",
		"chunk-2d0da745"
	],
	"./imprint/Imprint": [
		"bc16"
	],
	"./imprint/Imprint.vue": [
		"bc16"
	],
	"./imprint/index": [
		"6c57",
		"chunk-2d0da745"
	],
	"./imprint/index.js": [
		"6c57",
		"chunk-2d0da745"
	],
	"./language": [
		"826a",
		"chunk-2d0dd85b"
	],
	"./language/": [
		"826a",
		"chunk-2d0dd85b"
	],
	"./language/Language": [
		"2c1d"
	],
	"./language/Language.vue": [
		"2c1d"
	],
	"./language/index": [
		"826a",
		"chunk-2d0dd85b"
	],
	"./language/index.js": [
		"826a",
		"chunk-2d0dd85b"
	],
	"./learn": [
		"35ca",
		"chunk-2d0ba336"
	],
	"./learn/": [
		"35ca",
		"chunk-2d0ba336"
	],
	"./learn/Learn": [
		"6572"
	],
	"./learn/Learn.vue": [
		"6572"
	],
	"./learn/index": [
		"35ca",
		"chunk-2d0ba336"
	],
	"./learn/index.js": [
		"35ca",
		"chunk-2d0ba336"
	],
	"./login": [
		"80c1",
		"chunk-2d0dd61c"
	],
	"./login/": [
		"80c1",
		"chunk-2d0dd61c"
	],
	"./login/Login": [
		"4b3f"
	],
	"./login/Login.vue": [
		"4b3f"
	],
	"./login/index": [
		"80c1",
		"chunk-2d0dd61c"
	],
	"./login/index.js": [
		"80c1",
		"chunk-2d0dd61c"
	],
	"./my_vocabulary": [
		"9a23",
		"chunk-2d0efc7f"
	],
	"./my_vocabulary/": [
		"9a23",
		"chunk-2d0efc7f"
	],
	"./my_vocabulary/MyVocabulary": [
		"1a49"
	],
	"./my_vocabulary/MyVocabulary.vue": [
		"1a49"
	],
	"./my_vocabulary/index": [
		"9a23",
		"chunk-2d0efc7f"
	],
	"./my_vocabulary/index.js": [
		"9a23",
		"chunk-2d0efc7f"
	],
	"./passwordreset": [
		"4491",
		"chunk-2d0c0e8e"
	],
	"./passwordreset/": [
		"4491",
		"chunk-2d0c0e8e"
	],
	"./passwordreset/PasswordReset": [
		"4059"
	],
	"./passwordreset/PasswordReset.vue": [
		"4059"
	],
	"./passwordreset/index": [
		"4491",
		"chunk-2d0c0e8e"
	],
	"./passwordreset/index.js": [
		"4491",
		"chunk-2d0c0e8e"
	],
	"./quiz": [
		"9957",
		"chunk-2d0e66b8"
	],
	"./quiz/": [
		"9957",
		"chunk-2d0e66b8"
	],
	"./quiz/Quiz": [
		"ec90"
	],
	"./quiz/Quiz.vue": [
		"ec90"
	],
	"./quiz/index": [
		"9957",
		"chunk-2d0e66b8"
	],
	"./quiz/index.js": [
		"9957",
		"chunk-2d0e66b8"
	],
	"./settings": [
		"9715",
		"chunk-2d0e5eb8"
	],
	"./settings/": [
		"9715",
		"chunk-2d0e5eb8"
	],
	"./settings/Settings": [
		"65be"
	],
	"./settings/Settings.vue": [
		"65be"
	],
	"./settings/index": [
		"9715",
		"chunk-2d0e5eb8"
	],
	"./settings/index.js": [
		"9715",
		"chunk-2d0e5eb8"
	],
	"./signup": [
		"72db",
		"chunk-2d0d698f"
	],
	"./signup/": [
		"72db",
		"chunk-2d0d698f"
	],
	"./signup/SignUp": [
		"607b"
	],
	"./signup/SignUp.vue": [
		"607b"
	],
	"./signup/index": [
		"72db",
		"chunk-2d0d698f"
	],
	"./signup/index.js": [
		"72db",
		"chunk-2d0d698f"
	],
	"./vocabulary": [
		"8b58",
		"chunk-2d0e8c43"
	],
	"./vocabulary/": [
		"8b58",
		"chunk-2d0e8c43"
	],
	"./vocabulary/Vocabulary": [
		"40b3"
	],
	"./vocabulary/Vocabulary.vue": [
		"40b3"
	],
	"./vocabulary/index": [
		"8b58",
		"chunk-2d0e8c43"
	],
	"./vocabulary/index.js": [
		"8b58",
		"chunk-2d0e8c43"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a383";
module.exports = webpackAsyncContext;